module.exports = __webpack_public_path__ + "static/media/016.c9d33153.jpg";